export default __webpack_public_path__ + "static/bg-privacy-05fb117ae941a2285cca2e15e5950ae9.jpeg";